import {
  Component,
  Input,
  OnInit,
  SimpleChanges,
  OnChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { NavItemModel } from 'src/app/sharedFeatures/models/nav-item-model';
import { UserLoggedIn } from 'src/app/sharedFeatures/models/user-login.model';
import { AuthGuard } from 'src/app/sharedFeatures/services/auth-guard.service';
import { CurrentUserService } from 'src/app/sharedFeatures/services/current-user.service';
import { NavigationService } from 'src/app/sharedFeatures/services/navigation.service';
import { Icons } from 'src/assets/svgs/index.ts';
import { Logos } from 'src/assets/svgs/logos';

@Component({
  selector: 'system-code-side-bar',
  templateUrl: './system-code-side-bar.component.html',
  styleUrls: ['./system-code-side-bar.component.scss'],
})
export class SystemCodeSideBarComponent implements OnInit, OnChanges {
  navList: NavItemModel[] = [];
  currentUser: UserLoggedIn | null = null;
  @Input() Refresh: boolean = false;
  subscriptions: Subscription[] = [];
  isExpanded = false;
  activeIndex: number | null = null;
  icons = Icons as any;
  logos = Logos;

  constructor(
    private navigationService: NavigationService,
    public adminGuard: AuthGuard,
    private currentUserService: CurrentUserService,
    private router: Router
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    this.currentUser = this.currentUserService.getCurrentUser();

    this.getNavItems();
    let currentUrl = this.router.url;
    ////;
    if (currentUrl === '/') {
      this.activeIndex = this.navList.findIndex(
        item => item.link === '/system-code'
      );
    }
  }

  ngOnInit(): void {
    this.currentUser = this.currentUserService.getCurrentUser();

    this.getNavItems();
  }
  getNavItems() {
    ////;
    if (this.navList.length == 0) {
      this.navigationService.getNavItems().subscribe(res => {
        this.navList = res.sort((a, b) => a.order - b.order);
      });
    }
    console.log('navList2:', this.navList);
  }
  toggleMenu() {
    this.isExpanded = !this.isExpanded;
  }

  toggleSubmenu(item: any) {
    if (item.childs?.length) {
      item.expanded = !item.expanded;
    }
  }

  setActive(index: number) {
    this.activeIndex = index;
  }
}
